import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from '@auth0/auth0-angular';
import { MenuComponent } from './components/shared/menu/menu.component';
import { IdentificacionClienteComponent } from './components/estado-situacion/identificacion-cliente/identificacion-cliente.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { DireccionParticularComponent } from './components/estado-situacion/direccion-particular/direccion-particular.component';
import { EstadoSituacionStepperComponent } from './components/estado-situacion/estado-situacion-stepper/estado-situacion-stepper.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DireccionComercialComponent } from './components/estado-situacion/direccion-comercial/direccion-comercial.component';
import { StepperService } from './services/stepper.service';
import { AntecedentesOcupacionalesComponent } from './components/estado-situacion/antecedentes-ocupacionales/antecedentes-ocupacionales.component';
import { AntecedentesConvivienteComponent } from './components/estado-situacion/antecedentes-conviviente/antecedentes-conviviente.component';
import { ActivosComponent } from './components/estado-situacion/activos/activos.component';
import { ParticipacionSociedadesComponent } from './components/estado-situacion/participacion-sociedades/participacion-sociedades.component';
import { PasivosComponent } from './components/estado-situacion/pasivos/pasivos.component';
import { ResumenComponent } from './components/estado-situacion/resumen/resumen.component';
import { NuevaSolicitudCreditoComponent } from './components/nueva-solicitud-credito/nueva-solicitud-credito.component';
import { PerfilUsuarioComponent } from './components/perfil-usuario/perfil-usuario.component';
import { DataService } from './services/data.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonService } from './services/common.service';
import { PersonaService } from './services/persona.service';
import { SolicitudDetalleComponent } from './components/solicitud-detalle/solicitud-detalle.component';
import { DocumentosAdjuntosComponent } from './components/estado-situacion/documentos-adjuntos/documentos-adjuntos.component';
import { CURRENCY_MASK_CONFIG, CurrencyMaskConfig, CurrencyMaskModule } from 'ng2-currency-mask';
import { CustomCurrencyMaskConfig } from './models/helper/CustomCurrencyMaskConfig';
import { GoogleMapsModule } from '@angular/google-maps';
import { FooterComponent } from './components/shared/footer/footer.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { LoadingSpinnerComponent } from './components/shared/loading-spinner/loading-spinner.component';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { LoadingService } from './services/loading.service';
import { OfertasCreditoComponent } from './components/ofertas-credito/ofertas-credito.component';
import { OfertaDetalleComponent } from './components/oferta-detalle/oferta-detalle.component';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeEsCL from '@angular/common/locales/es-CL';
import { CapitalizeEnumPipe } from './pipes/capitalize-enum.pipe';
import { ButtonColorDirective } from './directives/button-color.directive';
import { ConversationDetailComponent } from './components/mensajes/conversation-detail/conversation-detail.component';
import { ConversationsListComponent } from './components/mensajes/conversations-list/conversations-list.component';
import { MaterialModule } from './material.module';
import { IniciarConversacionComponent } from './components/mensajes/iniciar-conversacion/iniciar-conversacion.component';
import { NotificationService } from './services/notification.service';
import { HomeComponent } from './components/home/home.component';
import { HistorialComponent } from './components/historial/historial.component';
import { MatButtonModule } from '@angular/material/button';

registerLocaleData(localeEsCL);

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    IdentificacionClienteComponent,
    DireccionParticularComponent,
    EstadoSituacionStepperComponent,
    DireccionComercialComponent,
    AntecedentesOcupacionalesComponent,
    AntecedentesConvivienteComponent,
    ActivosComponent,
    ParticipacionSociedadesComponent,
    PasivosComponent,
    HomeComponent,
    HistorialComponent,
    ResumenComponent,
    NuevaSolicitudCreditoComponent,
    PerfilUsuarioComponent,
    SolicitudDetalleComponent,
    DocumentosAdjuntosComponent,
    FooterComponent,
    LoadingSpinnerComponent,
    OfertasCreditoComponent,
    OfertaDetalleComponent,
    CapitalizeEnumPipe,
    ButtonColorDirective,
    ConversationDetailComponent,
    ConversationsListComponent,
    IniciarConversacionComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    MaterialModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AuthModule.forRoot({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        redirect_uri: window.location.origin
      }
    }),
    MatFormFieldModule,
    CurrencyMaskModule,
    CommonModule,
    MatButtonModule,
    FormsModule,
    GoogleMapsModule
  ],
  providers: [
    NotificationService,
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    LoadingService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    StepperService,
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    DataService,
    CommonService,
    PersonaService,
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CL' },
    { provide: LOCALE_ID, useValue: 'es-CL' },
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class AppModule { }
